<template>
	<div>
		<div
			style="
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 16px;
				padding: 12px 20px 0px;
			"
		>
			<div @click="closeDetail" style="color: #07111b">關閉</div>
			<div style="font-size: 18px; font-weight: bold">付款方式</div>
			<div style="color: #07111b">套用</div>
		</div>
		<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
		<div>
			<cube-radio-group class="radioStyle" style="padding: 0px 10px">
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding-right: 20px;
					"
				>
					<div>
						<cube-radio option="1" v-model="selectedPay">
							<div style="font-size: 15px; margin-left: 18px">
								<div>點數付款</div>
								<div style="font-size: 18px; font-weight: bold">
                                    尚有點數: 580 點</div>
							</div>
						</cube-radio>
					</div>
					<div style="font-size: 15px">充值</div>
				</div>
				<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
				<div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding-right: 20px;
					"
				>
					<div>
						<cube-radio option="2" v-model="selectedPay">
							<div style="font-size: 15px; margin-left: 18px">
								<div>信用卡</div>
								<div style="font-size: 18px; font-weight: bold">
                                    Mastercard *****5858</div>
							</div>
						</cube-radio>
					</div>
					<div style="font-size: 15px">
						<router-link :to="{ name: 'HomeStoreCredit' }" class="item"
							>選擇
						</router-link></div>
				</div>
				<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
                <div
					style="
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding-right: 20px;
					"
				>
					<div>
						<cube-radio option="3" v-model="selectedPay">
							<div style="font-size: 15px; margin-left: 18px">
								<div>現金付款</div>
							</div>
						</cube-radio>
					</div>
				</div>
				<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
			</cube-radio-group>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	data() {
		return {
			selectedPay: "",
		};
	},
	methods: {
		...mapActions({
			setRecharge: "setRecharge",
		}),
		closeDetail() {
			this.setRecharge(false);
		},
	},
};
</script>

<style scoped>
.radioStyle >>> .border-top-1px,
.border-right-1px,
.border-bottom-1px,
.border-left-1px {
	position: inherit !important;
}

</style>
